


import {
  DisplayModule,
  RouterModule,
  SectionsModule,
  ArgumentsModule,
  UsersModule,
  VotingModule,
  CommentsModule,
} from '@/store/store.helper';
import * as enums from '@/types/enums';
import { eventBus } from '@/main';
import {
  ArgumentInterface,
  SectionInterface,
  CommentInterface,
  } from '@/types/interfaces';
import Vue from 'vue';
import Component from 'vue-class-component';
import ownerData from '@/components/owner.data/owner.data.vue';
import cardComments from '../card.comments/card.comments.vue';
import { NavBarInterface} from '@/store/types';
import { colorDirective } from '@/directives/color-directive';
import { Prop } from 'vue-property-decorator';
import AddNew from '../../add.new/add.new';
import deletePopup from "../../delete.popup/delete.popup.vue";
import EditSection from "@/components/edit.section/edit.section";

@Component({
  components: {
    'owner-data': ownerData,
    'card-comments': cardComments,
    'delete-popup' : deletePopup,
     AddNew,
     EditSection
  },
  directives: {
    colorDirective,
  },
})
export default class CardArguments extends Vue {
  @Prop() public section: SectionInterface;
  @Prop() public sectionIndex: Number;
  @Prop() public parentSectionId: String;
  @Prop() public pageStatus: Number;
  @Prop() public sectionsLength: Number;
  @Prop() public isFeedIsDiscussion: Boolean;
  @Prop() public isDisplayed: Boolean;
  @Prop() public isUserEditor: Boolean;

  @DisplayModule.DisplayGetter private getColor;
  @DisplayModule.DisplayGetter private getBorderTopColor;
  @DisplayModule.DisplayGetter private dateFormatted;
  @DisplayModule.DisplayGetter private navBar: NavBarInterface;
  @DisplayModule.DisplayGetter private showDeleteButton;

  @DisplayModule.DisplayMutation private setNavBar;

  @RouterModule.RouterGetter private currentRoute;
  @RouterModule.RouterGetter private getPath;
  @RouterModule.RouterMutation private setTransitionName;
  @RouterModule.RouterAction private push;

  @SectionsModule.SectionsGetter private isStaticFeed;
  @SectionsModule.SectionsGetter private isSectionsInRevisions;
  @SectionsModule.SectionsGetter private isParentSection;
  @SectionsModule.SectionsGetter private isDynamicFeed;
  @SectionsModule.SectionsGetter private sectionById;
  @SectionsModule.SectionsGetter private sectionsByEdit;

  @ArgumentsModule.ArgumentsGetter private argumentBySectionId;
  @ArgumentsModule.ArgumentsGetter private isUserConvinced;
  @ArgumentsModule.ArgumentsAction private userConvinced;
  @ArgumentsModule.ArgumentsAction private userUnconvinced;

  @CommentsModule.CommentsGetter private commentsByArgumentId: (
    string,
  ) => CommentInterface[];
  @CommentsModule.CommentsGetter private commentsBySectionId: (
    string,
  ) => CommentInterface[];

  @UsersModule.UsersGetter private participantDisplayNameById;

  @UsersModule.UsersGetter private isSignedIn;
  @UsersModule.UsersGetter private userUid;
  @UsersModule.UsersAction private signIn;
  @UsersModule.UsersAction private checkUserProperties;

  @RouterModule.RouterAction private pushWithParams;

  @VotingModule.VotingGetter private isUserVoted;
  @VotingModule.VotingGetter private isSectionReachedToThreshold: (
    SectionInterface,
    VotesInterface,
  ) => boolean;
  private sectionArguments: ArgumentInterface[] = [];
  private sectionId: string = '';
  private argumentContent = {};
  private loading: boolean = false;
  private isShowNew: boolean = false;
  private enums = enums;
  private eventBus = eventBus;
  private dialog = false;
  private itemDeleteId: string = '';
  public action: number | string;
  private objectToAdd: string = '';
  // private editSuggestions:any = [];
  private styleConvincedButtonObject(argument) {
    return {
      'background-color': !this.isUserConvinced(argument)
        ? this.getColor(argument.type)
        : 'white',
      'color': this.isUserConvinced(argument)
        ? this.getColor(argument.type)
        : 'white',
      'border': '2px solid',
      'border-color': this.isUserConvinced(argument)
        ? this.getColor(argument.type)
        : 'white',
    };
  }

  public async mounted() {
    this.sectionId =
      this.pageStatus === enums.FEED_TYPE.sectionEdited
        ? this.section.edited![this.section.edited!.length - 1]
        : this.section.id!;
/*    this.editSuggestions = this.getEditSuggestions().sort((sectionA, sectionB) =>
        sectionA.threshold + sectionA.cons.length - sectionA.pros.length - sectionB.threshold - sectionB.cons.length + sectionB.pros.length
        || new Date(sectionB.createdAt).getTime() - new Date(sectionA.createdAt).getTime());*/
      eventBus.$on('closeBox', () => {
          this.isShowNew = false;
      });
      eventBus.$on('changeTab', (sectionId) => {
          if (sectionId === this.section.id) {
              this.$refs.tabs['value'] = 'tab-1';
          }
      });
  }

  private beforeDestroy() {
     eventBus.$off('closeBox');
  }

  get visibleArguments() {
    if (this.argumentBySectionId(this.sectionId).length > 0) {
      const theArray = this.isDisplayed
        ? this.argumentBySectionId(this.sectionId)
        : new Array(this.argumentBySectionId(this.sectionId)[0]);
      return theArray;
    } else { return []; }
  }

    /**
     * get edit suggestions length
     */
    /*    get editSuggestions() {
            try {
                if (this.section.toEdit && this.section.toEdit.length > 0) {
                    return this.section.toEdit;
                } else if (this.parentSectionId !== '0') {
                    if (this.sectionById(this.parentSectionId)[0].toEdit && this.sectionById(this.parentSectionId)[0].toEdit.length > 0) {
                        return this.sectionById(this.parentSectionId)[0].toEdit;
                    } else {
                        throw 'error';
                    }
                } else {
                    throw 'error';
                }
            } catch (e) {
                return [];
            }
        }*/

    get editSuggestions() {
        let sectionId;
        if (this.section.toEdit && this.section.toEdit.length > 0) {
            sectionId = this.section.id;
        } else if (this.parentSectionId !== '0') {
            sectionId = this.parentSectionId;
        }
        return this.sectionsByEdit(enums.FEED_TYPE.toEdit, sectionId)
            .filter(section => section.id != this.section.id);
    }

  /**
   * adding new argument
   */
  private async addNewArgument(action) {
      eventBus.$emit('closeBox');
      eventBus.$emit('nextBtn', true);
    if (!this.isSignedIn) {
      this.signIn();
    } else {
        this.objectToAdd = 'argument';
        this.action = action;
        this.isShowNew = true;
        eventBus.$emit('nextBtn', false);
    }
  }
    /**
     * adding new edit suggestion
     */

    private async addNewSection() {
        if (!this.isSignedIn) {
            this.signIn();
        } else {
            this.objectToAdd = 'section';
            this.action = enums.SECTION_STATUS.toEditInTheVote;
            this.isShowNew = false;
            this.isShowNew = true;
            eventBus.$emit('nextBtn', false);
        }
    }

  /**
   * route to feed page with this current section and open it's arguments
   */
  public routeAndToggle() {
    // if this is a discussion page and the arguments are opens -> close the arguments and go back to the feed
    if (this.isFeedIsDiscussion) {
      this.push({ path: this.navBar.path });
    } else if (!(<any>Object).values(enums.STATIC_STATUS).includes(this.pageStatus)) {
      this.setTransitionName('slide-right');
      if (this.pageStatus !== enums.FEED_TYPE.edited) {
        // route to section page with this specific section
        const path = this.getPath({
          name: enums.ROUTE_NAME.section,
          params: {
            [enums.SECTION_BY.sectionById]: this.section.id,
            index: this.sectionIndex,
          },
        });
        this.setNavBar({ path: this.currentRoute.fullPath });
        this.push({ path });
      }
    } else {
      eventBus.$emit('toggleArguments', {
        sectionId: this.sectionId,
      });
    }
  }

  public toggleComments(argumentId) {
    this.$refs[`commentsComponent${argumentId}`][0].toggleComments();
  }

  public addComment(argumentId) {
    // this.$refs[`commentsComponent${argumentId}`][0].addComment();
      if (!this.isSignedIn) {
          this.signIn();
      } else {
          eventBus.$emit('closeBox');
          eventBus.$emit('nextBtn', true);
          eventBus.$emit('showNewComment', argumentId);
      }
  }
  /**
   * user clicked on convinced button
   */
  public async convinced(argument) {
    console.log('Convinced on argument ' + JSON.stringify(argument));
    const vote = argument.type
      ? enums.VOTING_OPTIONS.pros
      : enums.VOTING_OPTIONS.cons;
    if (!this.isSignedIn) {
      this.signIn();
    } else {
      if (this.isUserConvinced(argument)) {
        console.log('User Unconvinced');
        await this.userUnconvinced(argument.id);
      } else {
        console.log('User Convinced');
        this.loading = true;
        await this.userConvinced(argument.id);
        if (
          this.isUserVoted(this.section, vote) ||
          this.isSectionReachedToThreshold(this.section, {
            pros: this.section.pros,
            cons: this.section.cons,
          })
        ) {
          this.loading = false;
          return;
        }
        const emitType = argument.type ? enums.VOTING_OPTIONS.pros : enums.VOTING_OPTIONS.cons;
        console.log('emit userVoted ' + emitType);
        await this.$emit('userVoted', emitType);
        this.loading = false;
      }
    }
  }

  private showDialog(itemId) {
    this.dialog = true;
    this.itemDeleteId = itemId
  }
}
